<template>
  <v-dialog
    v-model="dialog"
    max-width="30rem"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <v-list-item-content v-on="on">
        <v-list-item-subtitle>Configurer l'inventaire</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <v-card>
      <v-card-title>
        <v-row align="center" justify="end" no-gutters>
          <v-btn icon text @click="dialog = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-form ref="form" v-model="valid" @submit.prevent="save">
        <v-card-text>
          <v-row no-gutters>
            <v-switch
              :disabled="loading"
              v-model="data.use_inventory_correction"
              label="Utiliser l'ajustement automatique des transactions d'inventaire"
            ></v-switch>
          </v-row>
          <v-row no-gutters>
            <j-date-picker
              :disabled="loading"
              label="Considérer les corrections depuis le"
              v-model="data.global_inventory_correction_date"
            ></j-date-picker>
          </v-row>
          <v-row no-gutters>
            <v-btn
              small
              color="error"
              :disabled="loading"
              @click="resetCorrectionValues"
            >
              <v-icon x-small left>fa-sync</v-icon>Recalculer les valeurs
              d'ajustement
            </v-btn>
          </v-row>
          <v-row v-show="loading" align="center">
            <v-col cols="12">
              <v-progress-linear indeterminate></v-progress-linear>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row align="center" justify="end" no-gutters>
            <v-btn
              color="primary"
              type="submit"
              :disabled="!valid || loading"
              :block="$vuetify.breakpoint.xsOnly"
              :large="$vuetify.breakpoint.smAndDown"
            >
              <v-icon left small>fa-save</v-icon>Enregistrer
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "UserStoreInventorySettings",
  computed: {
    ...mapGetters(["getStoreId", "getStoreInfo"])
  },
  data() {
    return {
      loading: false,
      dialog: false,
      valid: false,
      data: {
        use_inventory_correction: true,
        global_inventory_correction_date: null
      }
    };
  },
  methods: {
    getData() {
      try {
        this.loading = true;
        this.data.use_inventory_correction = this.getStoreInfo.use_inventory_correction;
        this.data.global_inventory_correction_date = this.getStoreInfo.global_inventory_correction_date;
      } finally {
        this.loading = false;
      }
    },
    async save() {
      try {
        this.loading = true;
        if (this.valid === true) {
          const d = {
            use_inventory_correction: this.data.use_inventory_correction
          };
          if (this.data.global_inventory_correction_date !== null) {
            d.global_inventory_correction_date = this.data.global_inventory_correction_date;
          }
          const res = await api.patchStore(this.getStoreId, d);
          this.$store.commit("setStoreInfo", res);
          this.dialog = false;
        }
      } finally {
        this.loading = false;
      }
    },
    async resetCorrectionValues() {
      try {
        this.loading = true;
        await api.resetCorrectionValues();
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    dialog(v) {
      if (v === true) {
        this.getData();
      }
    }
  }
};
</script>

<style></style>
